import { NotificationTypesModalBasicData } from '@/modules/configurationModule/detail/notifications/components/notification-types-modal-basic-data-form/basic-data-form.model'
import { TranslationResponse } from '@/api/services/common.dto'

export enum NotificationTypesModalActiveTab {
    BASIC_DATA= 0,
    SUBJECT = 1,
    PLAIN_TEXT = 2,
    HTML_BODY = 3
}

export interface NotificationTypesModalState {
    id?: number
    activeTabIndex: NotificationTypesModalActiveTab.BASIC_DATA
    basicData?: NotificationTypesModalBasicData
    subjectTranslations: Partial<TranslationResponse>[]
    plainBodyTranslations: Partial<TranslationResponse>[]
    htmlBodyTranslations: Partial<TranslationResponse>[]
}
export const initialNotificationTypesModalState =
    (): NotificationTypesModalState => ({
        id: undefined,
        activeTabIndex: NotificationTypesModalActiveTab.BASIC_DATA,
        basicData: {
            emailChannelActive: false,
            inboxChannelActive: false,
            notificationType: null,
            smsChannelActive: false
        },
        subjectTranslations: [],
        htmlBodyTranslations: [],
        plainBodyTranslations: []
    })
